module.exports = __webpack_public_path__ + "img/user-black.65fe47bd.svg";